import React from "react";
import { PERFORMANCE_SERVICES } from "@/data/content";
import { PERF } from "@/constants/testIds";

const PORSCHE_IMG =
  "https://customer-assets.emergentagent.com/job_tesla-performance/artifacts/uhxr9dc7_IMG_0824.jpeg"; // Customer Porsche 911 3.0 SC 1981 — engine rebuild in OWRS workshop
const LR_IMG =
  "https://customer-assets.emergentagent.com/job_tesla-performance/artifacts/9icwqm9a_IMG_2669.jpeg"; // Customer Range Rover Velar — service & inspection at OWRS

export default function PerformanceServices() {
  return (
    <section id="performance" data-testid={PERF.section} className="section">
      <div className="container-owrs">
        <div className="grid lg:grid-cols-12 gap-12 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-4">01 — Performance & Prestige</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tighter leading-[1.05]">
              Where it all started — <br />
              <span className="text-[var(--owrs-text-muted)]">Porsche, Land Rover &amp; beyond.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base text-[var(--owrs-text-muted)] leading-relaxed">
              Road car servicing with the precision that motorsport demands. Routine
              maintenance through to complete bespoke race builds — carried out with the
              meticulous attention to detail that has earned us our reputation.
            </p>
          </div>
        </div>

        {/* Feature pair */}
        <div className="grid lg:grid-cols-2 gap-px bg-[var(--owrs-border)] mb-12">
          <div id="porsche">
            <FeatureTile
              image={PORSCHE_IMG}
              title="Porsche Specialists"
              body="From classic air-cooled servicing and engine rebuilds — as on this 1981 911 3.0 SC — to modern GT car prep, meticulous manufacturer-aware care for every generation."
            />
          </div>
          <div id="land-rover">
            <FeatureTile
              image={LR_IMG}
              title="Land Rover & Range Rover"
              body="Defender, Discovery, and Range Rover models — including this Velar in for service and inspection. Mechanical, electrical and diagnostic work by a team that knows them inside out."
            />
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--owrs-border)]">
          {PERFORMANCE_SERVICES.map((s, idx) => (
            <div
              key={s.slug}
              data-testid={PERF.card(s.slug)}
              className="bg-[var(--owrs-bg)] hover:bg-[var(--owrs-surface)] transition-colors duration-500 p-8 sm:p-10"
            >
              <div className="text-xs font-mono text-[var(--owrs-text-dim)] mb-6">
                /{String(idx + 1).padStart(2, "0")}
              </div>
              <h3 className="font-display text-xl sm:text-2xl font-medium tracking-tight mb-3">
                {s.title}
              </h3>
              <p className="text-sm text-[var(--owrs-text-muted)] leading-relaxed">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeatureTile({ image, title, body }) {
  return (
    <div className="relative h-[420px] sm:h-[480px] group overflow-hidden bg-[var(--owrs-surface)]">
      <img
        src={image}
        alt={title}
        className="absolute inset-0 h-full w-full object-cover opacity-60 group-hover:opacity-75 group-hover:scale-105 transition-all duration-700"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[var(--owrs-bg)] via-[var(--owrs-bg)]/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-8 sm:p-10">
        <h3 className="font-display text-2xl sm:text-3xl font-medium tracking-tight mb-2">
          {title}
        </h3>
        <p className="text-sm text-[var(--owrs-text-muted)] max-w-md leading-relaxed">
          {body}
        </p>
      </div>
    </div>
  );
}
